import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppUpdateBanner"] */ "/app/components/AppUpdateBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/features/auth/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfflineBanner"] */ "/app/features/sync/components/OfflineBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProvider"] */ "/app/lib/react-query/provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Mozilla_Text\",\"arguments\":[{\"subsets\":[\"latin\"],\"adjustFontFallback\":false}],\"variableName\":\"mozilla\"}");
